<script setup>
import MenuLayout from '@/pages/layout/MenuLayout.vue'
import { Pane, Splitpanes } from 'splitpanes'
import { onUnmounted, reactive } from 'vue'
import { useRouter,useRoute } from 'vue-router'
import 'splitpanes/dist/splitpanes.css'
import Vue3TreeVue from 'vue3-tree-vue'
import { useMetaStore } from '@/stores'
import { arrDepth, ensureRef, get, isDummyBbox, loadEpsgs, loadEpsgsWithPrjInit, openWin, post, postMultipart, qsel, senitizeLonLatBbox, toJson, validators, ymd } from '@/common/util'
import config from '@/common/config'
import _ from 'lodash-es'
import draggableComponent from 'vuedraggable'
import { transformExtent } from 'ol/proj'
import { buffer, getBottomLeft, getCenter, getHeight, getWidth } from 'ol/extent'
import TileLayer from 'ol/layer/Tile'
import { ImageWMS, OSM, TileWMS, XYZ } from 'ol/source'
import ZoomSlider from 'ol/control/ZoomSlider'
import { Map, View } from 'ol'
import {defaults as defaultControls} from 'ol/control/defaults.js'
import LayerGroup from 'ol/layer/Group'
import { VTextField } from 'vuetify/components/VTextField'
import MemPicker from '@/components/MemPicker.vue'
import DataDetail from '@/components/member/DataDetail.vue'
import Logs from '@/components/admin/config/Logs.vue'
import VectorLayer from 'ol/layer/Vector'
import VectorSource from 'ol/source/Vector'
import GeoJSON from 'ol/format/GeoJSON.js';
import WKT from 'ol/format/WKT.js';
import Modify from 'ol/interaction/Modify.js';
import Select from 'ol/interaction/Select.js';
import Draw from 'ol/interaction/Draw.js';
import Snap from 'ol/interaction/Snap.js';
import Translate from 'ol/interaction/Translate.js';
import {register} from 'ol/proj/proj4.js';
import {get as getProjection} from 'ol/proj.js';
import proj4 from 'proj4'
import {Circle, Fill, Stroke, Style} from 'ol/style.js';
import { click } from 'ol/events/condition'
import MousePosition from 'ol/control/MousePosition.js';
import { createStringXY } from 'ol/coordinate'
import { toContext } from 'ol/render'
import { fromExtent } from 'ol/geom/Polygon'
import ConfirmCard from '@/components/ConfirmCard.vue'
import { onMounted ,ref} from 'vue'
import ImageLayer from 'ol/layer/Image'
import BgMapSelector from '@/components/BgMapSelector.vue'
import { fi } from 'vuetify/locale'
import Cookies from "js-cookie"
const route=useRoute(),router=useRouter(),metaStore=useMetaStore(),bgselector=ref(null),thumbimg=ref(null)
const meta=reactive({showleft:true,showright:true,treeshown:true,groups:[],layers:[],data:[],maplayers:[],layertypes:['Point','LineString','Polygon'],isaddmode:true
  ,styleheads:[{tk:'preview'},{tk:'groupname',col:'groupid'},{tk:'name',col:'nm'},{tk:'registrationmodificationdate',col:'mdt'}],styles:{rows:[]},selstyle:'',inters:{},featureselected:false
  ,disableaddmode:false,fields:[],selfieldtype:'String',selfeaturetab:'prop',selfid:null,modifyfeature:{},modeditfeatures:{creates:[],dels:[],mods:[]},metalim:500,modfeaturetype:''})
,toList=()=>{
  router.push({path: '/admin/mandata/objectdetection'})
},findItem=({id,isod})=>{
  let item
  if(isod)meta.data.forEach(group=>group.children.forEach(lyr=>{
    if(lyr.id==id)item=lyr
  }))
  else meta.data.forEach(group=>{
    if(group.id==id)item=group
  })
  return item
},saveStyle=async()=>{
  const pd={id:meta.selod.id}
  if(meta.selstyle==='true'||meta.selstyle==='false'||meta.selstyle===true||meta.selstyle===false)pd.style=null
  else pd.style=meta.selstyle
  metaStore.blockLoading()
  const res=await post('rest/authed/admin/data/styletood',pd)
  metaStore.blockLoading(false)
  metaStore.toastRslt(res,true)
  if(!res.isSuccess)return
  meta.selod=res.data
  meta.selstyle=meta.selod.style
  meta.ods[meta.ods.findIndex(lyr=>lyr.id==meta.selod.id)]=toJson(meta.selod)
  initMapLayers()
  searchStyle()
},searchStyle=async(obj)=>{
  if(!meta.searchstylenm)meta.searchstylenm=''
  meta.styles={rows:[]}
  const spm={page:1,size:99999,isasc:false,sortcol:'mdt',where:{nm:meta.searchstylenm}}
  spm.fields=['id','nm','groupid','mdt','gsstylenms','styletype']
  spm.where.styletype_eq_=meta.selstyletype.replace('Multi','').replace('String','')
  metaStore.blockLoading()
  const res=await post('rest/authed/admin/data/layerstyles',spm)
  metaStore.blockLoading(false)
  meta.selstyle=meta.selod.style
  meta.styles=res.data
},save=async ()=>{
  metaStore.blockLoading()
  const savemodel={isupdatelayer:true,isupdatevector:false,isupdateraster:false}
  savemodel.od={...meta.selod}
  if(savemodel.od.groupid=='defaultgroups')savemodel.od.groupid=null
  savemodel.features=[]
  if(meta.onediting){
    const wktFormat=new WKT()
    _.entries(meta.modeditfeatures).forEach(ent=>ent[1].forEach(feature=>{
      const savefeature={}
      savefeature.odid=meta.selod.id
      savefeature.id=feature.getId()
      savefeature.layertype=feature.getGeometry().getType()
      savefeature.cdepth=arrDepth(feature.getGeometry().getCoordinates())
      savefeature.wkt=wktFormat.writeFeature(feature,{featureProjection:meta.map.getView().getProjection(),dataProjection:'EPSG:'+meta.selod.epsg})
      if(ent[0]=='creates')savefeature.cmdtype='create'
      if(ent[0]=='dels')savefeature.cmdtype='delete'
      if(ent[0]=='mods')savefeature.cmdtype='modify'
      savemodel.features.push(savefeature)
    }))
  }
  const res=await post('rest/authed/admin/data/saveod',savemodel)
  metaStore.blockLoading(false)
  metaStore.toastRslt(res,true)
  if(res.isSuccess)init(meta.selod.id)
},sub=async type=>{
  meta.subtype=null
  metaStore.pop({ison:false})
  modFeature()
  meta.showsub=false
  meta.subttl=null
  if(type=='selstyle'){
    meta.subttl=metaStore.t('chooseastyle')
    meta.selstyletype=meta.selod.layertype.replace('Multi','').replace('String','')
    await searchStyle()
  }
  if(type=='metadata')meta.subttl=metaStore.t('metadata')
  if(type=='datadetail')meta.subttl=metaStore.t('datadetails')
  if(type=='log')meta.subttl=metaStore.t('viewinglayerlogs')
  if(type=='share'||type=='save')return metaStore.pop({ison:true,callback:()=>meta.subtype=type})
  meta.showsub=true
  if(!type||type=='featuredetail')meta.showsub=false
  if(type!='featuredetail')clearSelFid()
  if(type=='featuredetail'){
    meta.selfeaturetab='prop'
  }
  meta.subtype=type
},getGeojson=async(layer,force,max=5000,bbox)=>{
  if(!force&&(!layer.gslayernm||meta.onediting||meta.selfid))return
  metaStore.blockLoading()
  const wpm={
    service: "WFS",
    version: "1.0.0",
    request: "GetFeature",
    typeName: layer.gslayernm,
    maxFeatures: 1,
    outputFormat: "application/json",
    srsName:'EPSG:'+layer.epsg
  }
  if(meta.totalFeatures==null){
    const geojson=await get('wfs',()=>{},wpm)
    meta.totalFeatures=geojson.totalFeatures
  }
  wpm.maxFeatures=max
  if(!bbox||!bbox.length){
    bbox=meta.map.getView().calculateExtent()
  }
  meta.lastextent=bbox
  const calced=transformExtent(bbox,meta.map.getView().getProjection().getCode(),'EPSG:'+layer.epsg)
  wpm.bbox=calced.toString()
  const geojson=await get('wfs',()=>{},wpm)
  meta.numberMatched=geojson.numberMatched
  meta.numberReturned=geojson.numberReturned
  meta.editlayer.getSource().clear()
  meta.editlayer.getSource().addFeatures(new GeoJSON().readFeatures(geojson,{dataProjection:'EPSG:'+meta.selod.epsg,featureProjection: meta.map.getView().getProjection()}))
  metaStore.blockLoading(false)
},debounceGetGeojson=_.debounce(getGeojson,300)
,clearSelFid=()=>{
  meta.selfid=null
  const radio=qsel('[name=selfid]:checked')
  if(radio)radio.checked=false
  meta.detaillayer.getSource().clear()
},modFeature=async flag=>{
  meta.modfeaturetype=''
  if(flag=='save'||flag=='del'){
    metaStore.blockLoading()
    const pd=toJson(meta.modifyfeature)
    _.entries(pd.attrs).forEach(ent=>pd.attrs[ent[0]]={type:meta.fields.find(field=>field.name==ent[0]).type,value:ent[1]})
    pd.refid=meta.selod.id
    pd.cmdtype=flag=='save'?'modify':'delete'
    if(flag=='del'){
      pd.attr=null
    }
    if(flag=='save'){
      const feature=meta.editlayer.getSource().getFeatureById(meta.modifyfeature.id).clone()
      feature.getGeometry().setCoordinates(meta.modifyfeature.coords)
      pd.wkt=new WKT().writeFeature(feature)
    }
    delete pd.coords
    const res=await post('rest/authed/admin/data/modifyodfeatures',[pd])
    metaStore.toastRslt(res,flag=='save')
    metaStore.blockLoading(false)
    flag=null
    if(res.isSuccess){
      initMapLayers(true)
      selTree(findItem({id:meta.selod.id,isod:true}),true)
      initMapLayers()
    }
  }
  meta.modfeaturetype=flag||''
  meta.featuremodpop=flag!=null
},thumbMod=async type=>{
  if(type=='save'&&meta.upthumb==null)return metaStore.toastKey('no_uploaded_files',false)
  if(!confirm(type=='save'?metaStore.t('save_con'):metaStore.t('del_con')))return
  metaStore.blockLoading()
  let res,featureid=meta.modifyfeature.attrs.featureid
  thumbimg.value.src=null
  if(type=='del'){
    res=await post('rest/authed/admin/data/objdetect/thumbnail/del/'+meta.selod.id+'/'+featureid)
    if(res.isSuccess){
      metaStore.toastKey('thedeletioniscomplete')
    }else{
      metaStore.toastKey('thedeletefailedpleasetryagaininamoment',false)
    }
  }else{
    res=await postMultipart('rest/authed/admin/data/objdetect/thumbnail/add',{file:meta.upthumb,odid:meta.selod.id,featureid:featureid})
    metaStore.toastRslt(res)
    if(res.isSuccess){
      meta.upthumb=null
      meta.modifyfeature.attrs.thumbnail=res.data.attr.thumbnail.value
      thumbimg.value.src=`${config.backend}rest/public/objdetect/thumbnail/${meta.selod.id}/${featureid}`
    }
  }
  metaStore.blockLoading(false)
},actSelFid=id=>{
  if(id&&id==meta.selfid){
    meta.map.getView().setCenter(getCenter(meta.editlayer.getSource().getFeatureById(id).clone().getGeometry().getExtent()))
    return
  }
  clearSelFid()
  sub()
  meta.modifyfeature={attrs:{}}
  if(!id)return
  const feature=meta.editlayer.getSource().getFeatureById(id).clone()
  meta.map.getView().setCenter(getCenter(feature.getGeometry().getExtent()))
  meta.selfid=id
  const radio=qsel('[value="'+id+'"]')
  radio.checked=true
  radio.scrollIntoView({block: 'center'})
  meta.disablemapevt=true
  meta.detaillayer.getSource().addFeature(feature.clone())
  meta.disablemapevt=false
  meta.fields.forEach(field=>{
    meta.modifyfeature.attrs[field.name]=feature.getProperties()[field.name]
    if(field.type=='Date'&&meta.modifyfeature.attrs[field.name])meta.modifyfeature.attrs[field.name]=new Date(feature.getProperties()[field.name])
  })
  feature.getGeometry().transform(meta.map.getView().getProjection(),'EPSG:'+meta.selod.epsg)
  meta.modifyfeature.id=id
  meta.modifyfeature.featureid=meta.modifyfeature.attrs.featureid
  meta.modifyfeature.layertype=feature.getGeometry().getType()
  meta.modifyfeature.coords=feature.getGeometry().getCoordinates()
  meta.modifyfeature.cdepth=arrDepth(meta.modifyfeature.coords)
  get('rest/authed/member/featurelink/objdetect/'+meta.modifyfeature.featureid,res=>{
    if(!res.data.id)return
    meta.modifyfeature.featurelink=res.data.url
  })
  sub('featuredetail')
  ensureRef(thumbimg,img=>img.src=`${config.backend}rest/public/objdetect/thumbnail/${meta.selod.id}/${meta.modifyfeature.attrs.featureid}`)
},selTree=async (item,force)=>{
  if(!item.isod)return
  if(force)meta.data.forEach(group=>group.children.forEach(lyr=>lyr.selected=false))
  if(item.isod&&item.selected){
    meta.showdetail=true
    return
  }
  sub()
  clearSelFid()
  meta.lastextent=null
  meta.numberMatched=0
  meta.numberReturned=0
  meta.detaillayer.getSource().clear()
  meta.onediting=false
  item.checked=false
  let gid=meta.ods.find(lyr=>lyr.id==item.id).groupid
  if(!gid)gid='defaultgroups'
  findItem({id:item.id,isod:true}).selected=true
  findItem({id:gid,isod:false}).expanded=true
  meta.selod=meta.ods.find(lyr=>lyr.id==item.id)
  if(!meta.selod.groupid)meta.selod.groupid='defaultgroups'
  meta.data.forEach(group=>group.children.forEach(lyr=>lyr.disabled=false))
  meta.showdetail=true
  meta.fields=[]
  let fts=await get('rest/authed/admin/data/featuretypes/'+meta.selod.gsworkspace+'/'+meta.selod.gslayernm)
  meta.fields=fts.data.featureType.attributes.attribute
  if(Array.isArray(meta.fields))meta.fields=meta.fields.filter(ft=>ft.name!='geometry'&&ft.name!='the_geom'&&ft.name!='FID'&&ft.name!='ID'&&ft.name!='fid'&&ft.name!='id'&&ft.name!='etc')
  else meta.fields=[]
  meta.fields.forEach(field=>field.type=_.last(field.binding.split('.')))
  if(!getProjection('EPSG:'+meta.selod.epsg))metaStore.toastKey('not_register_epsg',false)
  treeCheck(item)
  meta.totalFeatures=null
  debounceGetGeojson(meta.selod)
  toggleEdit()
  debounceGetGeojson(meta.selod)
  const lyrnm='od_'+item.id
  let bbox=meta.bboxes&&meta.bboxes[lyrnm]
  if(bbox&&!isDummyBbox(bbox)){
    meta.map.getView().fit(bbox,{padding:[100,100,100,100],callback:()=>{
      if(meta.map.getView().getZoom()>19)meta.map.getView().setZoom(19)
    }})
  }else metaStore.toast('해당 레이어의 영역정보가 없습니다.',false)
},layerDragEnd=()=>{
  initMapLayers()
},reorderTreeOd=async(item,isup)=>{
  const group = meta.data.find(gr => gr.id === item.groupid);
  if (!group || group.children.length < 2) return;
  const idx = group.children.findIndex(child => child.id === item.id);
  if (idx === -1) return;
  if (isup) {
    if (idx === 0) return;
    [group.children[idx - 1], group.children[idx]] = [group.children[idx], group.children[idx - 1]];
  } else {
    if (idx === group.children.length - 1) return;
    [group.children[idx], group.children[idx + 1]] = [group.children[idx + 1], group.children[idx]];
  }
  const orderingroup=[]
  group.children.forEach((od,idx)=>orderingroup.push({id:od.id,order:idx}))
  metaStore.blockLoading()
  const res=await post('rest/authed/admin/data/setodorders',orderingroup)
  metaStore.blockLoading(false)
  metaStore.toastRslt(res,true)
},treeCheck=item=>{
  const searched=findItem(item)
  const checked=!searched.checked
  if(!searched.isod)searched.children.forEach(lyr=>lyr.checked=checked)
  searched.checked=checked
  meta.mapods=[]
  meta.data.forEach(group=>group.children.forEach(lyr=>{
    if(lyr.checked||lyr.selected){
      lyr.checked=true
      meta.mapods.push({nm:lyr.name,id:lyr.id,shown:true})
    }
  }))
  initMapLayers()
},shareSaved=async targettype=>{
  metaStore.blockLoading()
  const res=await post('rest/authed/admin/data/setshareod',{id:meta.selod.id,sharetype:targettype})
  metaStore.blockLoading(false)
  meta.selod.sharetype=targettype
},filterLayer=txt=>{
  meta.data=toJson(meta.odata)
  const delids={}
  if(!_.isEmpty(txt))meta.data.forEach((group,gidx)=>group.children.forEach((lyr)=>{
    if(!lyr.name.toLowerCase().includes(txt.toLowerCase())){
      if(!delids[gidx])delids[gidx]=[]
      delids[gidx].push(lyr.id)
    }
  }))
  _.keys(delids).forEach(idx=>meta.data[idx].children=meta.data[idx].children.filter(lyr=>!delids[idx].includes(lyr.id)))
},findMapLayerById=(id)=>{
  let mlayer
  meta.layergroup.getLayers().forEach(lyr=>{
    if(lyr.get('odid')==id)mlayer=lyr
  })
  return mlayer
},setVisible=(id,visible)=>{
  const mlayer=findMapLayerById(id)
  if(mlayer)mlayer.setVisible(visible)
},delFeature=()=>{
  meta.inters.sel.getFeatures().forEach(fea=>{
    meta.featureselected=false
    meta.editlayer.getSource().removeFeature(fea)
    let idx=meta.modeditfeatures.creates.indexOf(fea)
    if(idx>-1)meta.modeditfeatures.creates.splice(idx,1)
    idx=meta.modeditfeatures.mods.indexOf(fea)
    if(idx>-1)meta.modeditfeatures.mods.splice(idx,1)
    if(fea.getId()&&!meta.modeditfeatures.dels.includes(fea))meta.modeditfeatures.dels.push(fea)
  })
  meta.inters.sel.getFeatures().clear()
},setAddMode=()=>{
  meta.inters.sel.setActive(!meta.isaddmode)
  meta.inters.mod.setActive(!meta.isaddmode)
  meta.inters.trans.setActive(false)
  meta.inters.draw.setActive(meta.isaddmode)
  meta.inters.snap.setActive(false)
  meta.inters.sel.getFeatures().clear()
},toggleEdit=async()=>{
  if(meta.onediting)sub()
  meta.detaillayer.getSource().clear()
  meta.data.forEach(group=>group.children.forEach(item=>{
    item.disabled=meta.onediting
    if(item.selected)item.disabled=false
  }))
  setVisible(meta.selod.id,!meta.onediting)
  meta.featureselected=false
  _.keys(meta.inters).forEach(key=>{
    meta.map.removeInteraction(meta.inters[key])
    meta.inters[key]=null
  })
  meta.editlayer.setVisible(meta.onediting)
  meta.modeditfeatures={creates:[],dels:[],mods:[]}
  await getGeojson(meta.selod,true)
  if(!meta.onediting)return
  meta.inters.sel=new Select({condition:click,style:meta.vectorselstyle})
  meta.inters.sel.on('select',evt=>{
    meta.featureselected=meta.inters.sel.getFeatures().getArray().length>0
  })
  meta.inters.draw=new Draw({source:meta.editlayer.getSource(),type:meta.selod.layertype})
  meta.inters.draw.on('drawend',evt=>{
    meta.inters.sel.getFeatures().clear()
    evt.feature.set('created',true)
    meta.modeditfeatures.creates.push(evt.feature)
  })
  meta.inters.mod=new Modify({features: meta.inters.sel.getFeatures()})
  meta.inters.mod.on('modifyend',evt=>{
    evt.features.forEach(fea=>{
      if(fea.get('created'))return
      fea.set('modified',true)
      if(!meta.modeditfeatures.mods.includes(fea))meta.modeditfeatures.mods.push(fea)
    })
  })
  meta.inters.snap=new Snap({source:meta.editlayer.getSource()})
  meta.inters.trans = new Translate({features: meta.inters.sel.getFeatures()})
  meta.inters.trans.on('translateend',evt=>{
    evt.features.forEach(fea=>{
      if(fea.get('created'))return
      fea.set('modified',true)
      if(!meta.modeditfeatures.mods.includes(fea))meta.modeditfeatures.mods.push(fea)
    })
  })
  _.keys(meta.inters).forEach(key=>meta.map.addInteraction(meta.inters[key]))
  meta.disableaddmode=false
  meta.isaddmode=true
  meta.editlayer.setStyle(meta.vectorstyle)
  setAddMode()
},toMapLayer=(item)=>{
  const layer=meta.ods.find(lyr=>lyr.id==item.id)
 if(!layer.gslayernm)return
  const params={LAYERS:layer.gslayernm}
  if(!_.isEmpty(layer.style))params.STYLES=layer.style
  const mlayer = new ImageLayer({source:new ImageWMS({url:config.backend+'wms',params:params})})
  if(!_.isEmpty(layer.style)){
      mlayer.getSource().setImageLoadFunction((image, src) => {
        const resolution = meta.map.getView().getResolution();
        const meterRadius = 30 * resolution;
        image.getImage().src = src+`&env=layer:${layer.gsworkspace}:${layer.gslayernm};meter:${meterRadius}`;
      });
    }
  mlayer.getSource().on('imageloaderror', function (event) {
    metaStore.toast(`로드 에러:데이터/스타일을 확인해 주세요`,false)
  })
  return mlayer
},initMapLayers=clear=>{
  meta.layergroup.getLayers().clear()
  if(clear)return
  meta.mapods.toReversed().forEach(item=>{
    const maplayer=toMapLayer(item)
    if(maplayer){
      maplayer.set('odid',item.id)
      maplayer.setVisible(item.shown)
      if(meta.onediting&&item.id==meta.selod.id)maplayer.setVisible(false)
      meta.layergroup.getLayers().push(maplayer)
    }
  })
},initMap=()=>{
  const layerGroup=new LayerGroup({layers:[]})
  meta.vectorstyle=(feature,res)=>{
    let color='rgba(90, 90, 90, 1.0)',fillcolor='rgba(200, 200, 200, 1.0)'
    if(feature.get('modified')){
      color='rgba(255, 140, 0, 1.0)'
      fillcolor='rgba(120, 60, 0, 1.0)'
    }
    if(feature.get('created')){
      color='rgba(255, 50, 50, 1.0)'
      fillcolor='rgba(150, 0, 0, 1.0)'
    }
    const fill=new Fill({color: fillcolor})
    const style=new Style({fill: fill,stroke: new Stroke({color: color,width: 3})})
    style.setImage(new Circle({fill:fill,stroke:style.getStroke(),radius:5}))
    return style
  }
  meta.rasterstyle=new Style({
    renderer: function (pixelCoordinates, state) {
      const context = state.context;
      const geometry = state.geometry.clone();
      geometry.setCoordinates(pixelCoordinates);
      const extent = geometry.getExtent();
      const width = getWidth(extent);
      const height = getHeight(extent);
      const img = state.feature.get('img');
      if (!img || height < 1 || width < 1) {
        return;
      }
      context.save();
      const renderContext = toContext(context, {
        pixelRatio: 1,
      })
      let color='rgba(90, 90, 90, 1.0)',fillcolor='rgba(0, 0, 0, 0)'
      if(meta.inters.sel.getFeatures().getLength())color='rgba(0, 30, 120, 1.0)'
      renderContext.setFillStrokeStyle(new Fill({color: fillcolor}),new Stroke({color: color,width: 3}))
      renderContext.drawGeometry(geometry)
      context.clip()
      const bottomLeft = getBottomLeft(extent)
      const left = bottomLeft[0]
      const bottom = bottomLeft[1]
      context.drawImage(img, left, bottom, width, height)
      context.restore()
    }
  })
  meta.vectorselstyle=(feature,res)=>{
    const fill=new Fill({color: 'rgba(0, 90, 255, 1.0)'}),stroke=new Stroke({color: 'rgba(255, 105, 180, 1.0)',width:5})
    return new Style({fill:fill,stroke:stroke,image:new Circle({fill:fill,stroke:stroke,radius:5})})
  }
  meta.editlayer=new VectorLayer({
    source:new VectorSource()
  })
  meta.detaillayer=new VectorLayer({
    source:new VectorSource(),style:meta.vectorselstyle
  })
  const basemapgroup=new LayerGroup()
  basemapgroup.set('nm','basemapgroup')
  meta.map=new Map({layers:[basemapgroup,layerGroup,meta.detaillayer,meta.editlayer],target:'editmap'
    ,controls:defaultControls().extend([new ZoomSlider(),new MousePosition({projection:'EPSG:4326',coordinateFormat: createStringXY(4)})])
    ,view:new View()})
  meta.basemapgroup=basemapgroup
  let ext=[config.KoreaBbox.lonMin,config.KoreaBbox.latMin,config.KoreaBbox.lonMax,config.KoreaBbox.latMax]
  ext=transformExtent(ext,'EPSG:4326',meta.map.getView().getProjection())
  meta.map.getView().fit(ext)
  meta.map.getView().on('moveend',evt=>{
    if(meta.disablemapevt)return
    debounceGetGeojson(meta.selod)
  })
  window.map=meta.map
  meta.map.getView().on('change:resolution',evt=>{
    if(meta.disablemapevt)return
    debounceGetGeojson(meta.selod)
  })
  meta.map.getView().on('change:center',evt=>{
    if(meta.disablemapevt)return
    debounceGetGeojson(meta.selod)
  })
  meta.map.once('rendercomplete',evt=>{
    meta.maploaded=true
  });
  meta.map.on('singleclick',evt=>{
    if(meta.onediting||!meta.showdetail)return
    meta.editlayer.setOpacity(0)
    meta.editlayer.setVisible(true)
    meta.disablemapevt=true
    setTimeout((map,pixel) => {
      const features=map.getFeaturesAtPixel(pixel,{layerFilter:layer=>layer==meta.editlayer})
      meta.editlayer.setOpacity(1)
      meta.editlayer.setVisible(false)
      if(features.length)actSelFid(features[0].getId())
      else actSelFid()
      meta.disablemapevt=false
    }, 100,evt.map,evt.pixel)
  })
  meta.layergroup=layerGroup
},openManStyle=async()=>{
  openWin(config.frontRoot+'admin/mandata/managestyles')
},init=async(id)=>{
  meta.treeshown=false
  metaStore.blockLoading()
  let res=await get('rest/authed/member/groups/Objdetect')
  meta.groups=_.sortBy(res.data.map(group=>({name:group.nm,id:group.id,gorder:group.gorder,children:[],selected:false,checked:false})),'gorder')
  res=await post('rest/authed/member/objdetects')
  meta.ods=_.sortBy(res.data,'order')
  meta.data=[...meta.groups]
  meta.data.unshift({name:metaStore.t('defaultgroups'),id:null,gorder:-1,children:[],selected:false,checked:false})
  meta.data.forEach(item=>item.disabled=true)
  meta.ods.forEach(lyr=>meta.data.find(group=>group.id==lyr.groupid)
    .children.push({name:lyr.nm,id:lyr.id,layertype:lyr.layertype,groupid:(lyr.groupid??'defaultgroups'),isod:true,selected:false,checked:false}))
  meta.data[0].id='defaultgroups'
  meta.odata=toJson(meta.data)
  if(id)meta.selod=meta.ods.find(lyr=>lyr.id==route.params.id)
  loadEpsgsWithPrjInit(async epsgs=>{
    meta.epsgs=epsgs
    if(!meta.map)initMap()
    metaStore.blockLoading(false)
    fetch(config.backend+'wms?REQUEST=GetCapabilities').then(response => response.text()).then(str => {
      const parser = new DOMParser()
      const xmlDoc = parser.parseFromString(str, 'application/xml')
      meta.bboxes={}
      xmlDoc.querySelector('Layer').querySelectorAll('Layer').forEach(lyrcapa=>{
        const ttl=lyrcapa.querySelector('Title').textContent
        if(!ttl.includes('od_'))return
        let bbox=lyrcapa.querySelector('BoundingBox')
        const crs=bbox.getAttribute('CRS')
        const minx=bbox.getAttribute('minx')
        const miny=bbox.getAttribute('miny')
        const maxx=bbox.getAttribute('maxx')
        const maxy=bbox.getAttribute('maxy')
        if(crs.includes(':84')||crs.includes('4326'))bbox=senitizeLonLatBbox(minx,miny,maxx,maxy)
        else bbox=[minx,miny,maxx,maxy]
        if(bbox.some(a=>a=='-1.0E-4'))return
        bbox=transformExtent(bbox,crs,meta.map.getView().getProjection())
        if(bbox&&!bbox.toString().includes('Infinity')&&!bbox.some(pt=>pt==0))meta.bboxes[ttl]=bbox
      })
      meta.treeshown=true
      if(meta.selod)selTree(findItem({id:meta.selod.id,isod:true}))
    })
  })
}
onMounted(()=>{
  Cookies.set('admdatamenu','objectdetection')
  init(route.params.id)
})
onUnmounted(()=>{
  if(!meta.map)meta.map.setTarget(null)
})
</script>
<template>
  <MenuLayout>
    <div class="editlayer">
      <div v-if="meta.showleft" class="editod_left">
        <v-card flat class="me-2">
          <v-card-title>
            <v-row no-gutters>
              <v-col cols="2"><v-btn variant="text" density="compact" icon="mdi-arrow-left" @click="toList"/></v-col>
              <v-col>{{$t('objectdetection')}} {{$t('lists')}}</v-col>
            </v-row>
          </v-card-title>
          <v-divider/>
          <v-card-text class="pa-1">
            <Splitpanes horizontal class="default-theme">
              <Pane size="60">
                <v-text-field hide-details clearable variant="outlined" density="compact" class="mt-3 mb-2" :label="$t('layername')" :placeholder="$t('enteralayername')" @update:model-value="filterLayer"/>
                <Vue3TreeVue v-if="meta.treeshown" class="editlayertree" :items="meta.data" @onSelect="selTree">
                  <template #item-prepend-icon="item">
                    <v-icon v-if="!item.isod" icon="mdi-folder"/>
                    <v-icon v-else-if="item.layertype.includes('Point')" icon="mdi-vector-point"/>
                    <v-icon v-else-if="item.layertype.includes('Line')" icon="mdi-vector-line"/>
                    <v-icon v-else-if="item.layertype.includes('Polygon')" icon="mdi-vector-polygon"/>
                  </template>
                  <template #item-prepend="item">
                    <v-checkbox hide-details density="compact" width="25" :model-value="item.checked" :disabled="item.selected" @click.stop="treeCheck(item)"/>
                  </template>
                  <template #item-append="item">
                    <div v-if="item.isod" class="flex-grow-1 text-right" style="width: 80px;">
                      <v-btn icon="mdi-arrow-up-bold" size="x-small" variant="text" color="primary" @click.stop="reorderTreeOd(item,true)"/>
                      <v-btn icon="mdi-arrow-down-bold" size="x-small" variant="text" color="secondary" @click.stop="reorderTreeOd(item,false)"/>
                    </div>
                  </template>
                </Vue3TreeVue>
              </Pane>
              <Pane v-if="meta.selbgmid" size="40" style="overflow-y: auto;">
                <p class="text-center pt-2 pb-2 bg-purple-darken-2">{{ $t('layervieworder') }}</p>
                <v-divider/>
                <draggableComponent v-model="meta.mapods" item-key="id" @end="layerDragEnd">
                  <template #item="{element}">
                    <v-alert block border="start" density="compact" :icon="element.shown?'mdi-eye-outline':'mdi-eye-off-outline'" class="ma-1 cursor-pointer" :text="element.nm" @click="evt=>{
                      element.shown=!element.shown
                      setVisible(element.id,element.shown)
                    }"/>
                  </template>
                </draggableComponent>
                <v-alert block border="start" color="info" density="compact" class="ma-1 cursor-pointer" :text=" $t('backgroundmap')"
                  :icon="meta.basemapgroup.getLayersArray().some(lyr=>lyr.getVisible())?'mdi-eye-outline':'mdi-eye-off-outline'"
                  @click="()=>{
                    if(meta.basemapgroup.getLayersArray().some(lyr=>lyr.getVisible()))bgselector.hideAll()
                    else bgselector.selBgMap(meta.selbgmid)
                  }"/>
              </Pane>
            </Splitpanes>
          </v-card-text>
        </v-card>
      </div>
      <div class="editod_right">
        <div class="bgselwrap">
          <BgMapSelector ref="bgselector" :map="meta.map" width="100%" :onLoad="(bgms)=>meta.bgms=bgms" :onUpdate="bid=>meta.selbgmid=bid"/>
        </div>
        <div id="editmap" class="w-100 h-100" :style="'border: 4px solid '+(meta.onediting?'red':'white')+';'"/>
        <v-switch v-if="meta.onediting" hide-details density="compact" color="error" style="position: absolute;top:0px;right: 40px;z-index: 10;" v-model="meta.isaddmode" :disabled="meta.disableaddmode" @update:model-value="setAddMode">
          <template #prepend>
            <label>{{ $t('modify') }}</label>
          </template>
          <template #append>
            <label>{{ $t('new') }}</label>
          </template>
        </v-switch>
        <v-card v-if="meta.onediting" position="absolute" class="pa-2" width="120" style="top:40px;right: 40px;z-index: 10;font-size: 12px;">
          <div><v-icon icon="mdi-circle" style="color: rgba(255, 50, 50, 1.0);"/>{{ $t('new') }}</div>
          <div><v-icon icon="mdi-circle" style="color: rgba(0, 90, 255, 1.0);"/>{{ $t('selection') }}</div>
          <div><v-icon icon="mdi-circle" style="color: rgba(255, 140, 0, 1.0);"/>{{ $t('modify') }}</div>
        </v-card>
        <v-btn v-if="meta.featureselected" density="compact" color="error" position="absolute" style="top:120px;right: 40px;width: 120px;;z-index: 10;" :text="$t('delete')" @click="delFeature"/>
        <v-icon :icon="'mdi-chevron-'+(meta.showleft?'left':'right')" class="editod_left_tglbtn" @click="meta.showleft=!meta.showleft"/>
        <v-card v-if="meta.showdetail" position="absolute" width="350px" class="editod_detail">
          <v-card-title>
            <v-row>
              <v-col cols="10">{{ $t('od_detail_edit') }}</v-col>
              <v-col class="text-right">
                <v-btn variant="text" density="compact" icon="mdi-close" @click="meta.showdetail=false;sub()"/>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text class="pt-3" style="height: calc(100% - 100px);overflow-y: auto;">
            <v-defaults-provider :defaults="{VSelect:{hideDetails:true,variant:'outlined',density:'compact'},VTextField:{variant:'outlined',density:'compact'}}">
              <v-row no-gutters class="mb-4">
                <v-col>
                  <v-select :disabled="meta.onediting" :items="meta.data" v-model="meta.selod.groupid" :label="$t('groupname')" :item-props="item=>({title:item.name,value:item.id})"/>
                </v-col>
              </v-row>
              <v-row no-gutters v-if="meta.selod.etc!=null">
                <v-col><v-text-field :disabled="meta.onediting" :label="$t('newgroupname')" maxlength="50" :placeholder="$t('enteranameforyourgroupupto50characters')" :rules="[validators.required]" v-model="meta.selod.etc"/></v-col>
              </v-row>
              <v-row no-gutters>
                <v-col><v-text-field :disabled="meta.onediting" :label="$t('name')" maxlength="50" :placeholder="$t('enteranameforyourgroupupto50characters')" :rules="[validators.required]" v-model="meta.selod.nm"/></v-col>
              </v-row>
              <v-row no-gutters>
                <v-col>
                  <v-select class="mb-4" :items="meta.epsgs" v-model="meta.selod.epsg" :label="$t('coordinatesystem')" :item-props="item=>({title:'EPSG:'+item,value:item})"/>
                </v-col>
                <v-col>
                  <v-select :items="['UTF-8']" v-model="meta.selod.encoding" :label="$t('encodingtype')"/>
                </v-col>
              </v-row>
              <div>
                <v-row>
                  <v-col>
                    <v-btn :disabled="meta.onediting" block prepend-icon="mdi-map-marker-check-outline" :text="$t('chooseastyle')" @click="sub('selstyle')"/>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col align-self="center">{{ $t('itemlist') }} <span v-if="meta.totalFeatures!=null">({{meta.numberReturned}}/{{meta.totalFeatures}})</span></v-col>
                  <v-col><v-switch hide-details color="primary" :label="$t('mapeditmode')" v-model="meta.onediting" @update:model-value="toggleEdit"/></v-col>
                </v-row>
              </div>
              <v-card v-if="!meta.onediting&&meta.editlayer" flat>
                <div class="edititemtbl">
                  <table>
                    <thead>
                      <tr>
                        <th></th>
                        <th>No.</th>
                        <th>TYPE</th>
                        <th>ID</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="row in meta.editlayer.getSource().getFeatures().map((fea,idx)=>({no:idx+1,type:meta.selod.layertype.replace('Multi',''),id:fea.getId()}))" @click="actSelFid(row.id)">
                        <td><input type="radio" name="selfid" :value="row.id" :checked="row.id==meta.selfid"/></td>
                        <td>{{ row.no }}</td>
                        <td>{{ $t(row.type) }}</td>
                        <td>{{ row.id }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </v-card>
              <p>{{ $t('sharingdatadetails') }}</p>
              <v-row>
                <v-col>
                  <v-btn :disabled="meta.onediting" block :text="$t('managesharing')" @click="sub('share')"/>
                </v-col>
                <v-col>
                  <v-btn :disabled="meta.onediting" block :text="$t('datadetails')" @click="sub('datadetail')"/>
                </v-col>
              </v-row>
              <p>{{ $t('showlog_metadata') }}</p>
              <v-row>
                <v-col>
                  <v-btn :disabled="meta.onediting" block :text="$t('viewinglogs')" @click="sub('log')"/>
                </v-col>
                <v-col>
                  <v-btn :disabled="meta.onediting" block :text="$t('metadata')" @click="sub('metadata')"/>
                </v-col>
              </v-row>
            </v-defaults-provider>
          </v-card-text>
          <v-card-actions style="position: absolute;left: 0;right: 0;bottom: 0;">
            <v-row>
              <v-col><v-btn block variant="elevated" :text="$t('cancel')" @click="meta.showdetail=false"/></v-col>
              <v-col><v-btn block variant="elevated" color="primary" :text="$t('save')" @click="sub('save')"/></v-col>
            </v-row>
          </v-card-actions>
        </v-card>
        <v-card v-if="meta.showdetail&&meta.subtype=='featuredetail'" position="absolute" width="350px" class="editod_featuredetail">
          <v-card-title>
            <v-row>
              <v-col>{{$t('details')}}</v-col>
              <v-col class="text-right">
                <v-btn variant="text" density="compact" icon="mdi-close" @click="sub()"/>
              </v-col>
            </v-row>
          </v-card-title>
          <v-tabs v-model="meta.selfeaturetab" align-tabs="center" grow>
              <v-tab v-for="type in ['prop','coords']" :value="type">{{ $t(type=='prop'?'aboutpropertyfields':'coordinateinformation') }}</v-tab>
            </v-tabs>
          <v-card-text>
            <v-tabs-window v-model="meta.selfeaturetab">
                <v-defaults-provider :defaults="{global:{hideDetails:true,variant:'outlined',density:'compact'}}">
                  <v-tabs-window-item value="prop" class="pt-2">
                    <v-row><v-col>
                        <v-text-field label="ID" v-model="meta.selfid" disabled/>
                    </v-col></v-row>
                    <v-row><v-col>
                        <v-text-field label="FEATUREID" v-model="meta.modifyfeature.attrs.featureid" disabled/>
                    </v-col></v-row>
                    <v-row><v-col>
                        <v-text-field label="REFID" v-model="meta.modifyfeature.attrs.refid" disabled/>
                    </v-col></v-row>
                    <v-row v-for="field in meta.fields.filter(field=>['memo', 'thumbnail', 'featureid', 'refid', 'featurelink'].indexOf(field.name)==-1)">
                      <v-col>
                        <v-text-field v-if="field.type=='String'" :label="$t(field.name)+`(${field.type})`" v-model="meta.modifyfeature.attrs[field.name]"/>
                        <v-number-input v-else-if="field.type=='Integer'||field.type=='Long'" :label="$t(field.name)+`(${field.type})`" inset aria-hidden="false" :precision="0" v-model="meta.modifyfeature.attrs[field.name]"/>
                        <v-number-input v-else-if="field.type=='Double'" :label="$t(field.name)+`(${field.type})`" inset aria-hidden="false" :precision="5" v-model="meta.modifyfeature.attrs[field.name]"/>
                        <v-checkbox v-else-if="field.type=='Boolean'" :label="$t(field.name)+`(${field.type})`" v-model="meta.modifyfeature.attrs[field.name]"/>
                        <v-date-input v-else-if="field.type=='Date'" :label="$t(field.name)+`(${field.type})`" prepend-icon="" prepend-inner-icon="mdi-calendar" v-model="meta.modifyfeature.attrs[field.name]"/>
                      </v-col>
                    </v-row>
                    <v-row><v-col>
                        <v-textarea :label="$t('extlink')" v-model="meta.modifyfeature.featurelink"/>
                    </v-col></v-row>
                    <v-row><v-col>
                        <v-textarea :label="$t('memo')" v-model="meta.modifyfeature.attrs.memo"/>
                    </v-col></v-row>
                    <v-row>
                      <v-col class="text-subtitle-2">{{ $t('thumbnail') }}:</v-col>
                      <v-col>{{ meta.modifyfeature.attrs.thumbnail }}</v-col>
                    </v-row>
                    <v-row v-if="!meta.thumbexists">
                      <v-col>{{$t('noimg') }}</v-col>
                    </v-row>
                    <v-row v-show="meta.thumbexists">
                       <v-col>
                        <img ref="thumbimg" style="width: 100%;max-height: 500px;" @load="evt=>meta.thumbexists=true" @error="evt=>meta.thumbexists=false"/>
                        </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <v-file-upload clearable density="compact" variant="compact" v-model="meta.upthumb"></v-file-upload>
                      </v-col>
                    </v-row>
                    <v-row class="mb-3">
                      <v-col><v-btn block :text="$t('upload')" variant="elevated" color="primary" @click="thumbMod('save')"/></v-col>
                      <v-col><v-btn block :text="$t('delete')" color="error" variant="elevated" @click="thumbMod('del')"/></v-col>
                    </v-row>
                  </v-tabs-window-item>
                  <v-tabs-window-item v-if="meta.modifyfeature.layertype" value="coords" class="pt-2">
                    <v-alert v-if="meta.modifyfeature.layertype.includes('Multi')" v-for="(coords,idx) in meta.modifyfeature.coords" class="ma-1">
                      <p class="text-center">{{ idx+1 }}</p>
                      <table v-if="meta.modifyfeature.layertype.includes('Line')">
                          <thead>
                            <tr>
                              <th>{{ $t('xcoordinate') }}</th>
                              <th>{{ $t('ycoordinate') }}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(subcoords,subidx) in coords">
                              <td><input class="w-100" type="number" step="0.0001" v-model="meta.modifyfeature.coords[idx][subidx][0]"/></td>
                              <td><input class="w-100" type="number" step="0.0001" v-model="meta.modifyfeature.coords[idx][subidx][1]"/></td>
                            </tr>
                          </tbody>
                        </table>
                      <v-alert v-if="meta.modifyfeature.layertype.includes('Polygon')" v-for="(subcoords,subidx) in coords">
                        <table>
                          <thead>
                            <tr>
                              <th>{{ $t('xcoordinate') }}</th>
                              <th>{{ $t('ycoordinate') }}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(incoords,inidx) in subcoords">
                              <td><input class="w-100" type="number" step="0.0001" v-model="meta.modifyfeature.coords[idx][subidx][inidx][0]"/></td>
                              <td><input class="w-100" type="number" step="0.0001" v-model="meta.modifyfeature.coords[idx][subidx][inidx][1]"/></td>
                            </tr>
                          </tbody>
                        </table>
                      </v-alert>
                    </v-alert>
                    <div v-else>
                      <v-row v-if="meta.modifyfeature.layertype.includes('Point')">
                        <v-col><v-number-input :label="$t('xcoordinate')" :precision="5" v-model="meta.modifyfeature.coords[0]"/></v-col>
                        <v-col><v-number-input :label="$t('ycoordinate')" :precision="5" v-model="meta.modifyfeature.coords[1]"/></v-col>
                      </v-row>
                      <v-row v-if="meta.modifyfeature.layertype.includes('Line')" v-for="(subcoords,subidx) in coords">
                        <v-col><v-number-input :label="$t('xcoordinate')" :precision="5" v-model="meta.modifyfeature.coords[0][subidx][0]"/></v-col>
                        <v-col><v-number-input :label="$t('ycoordinate')" :precision="5" v-model="meta.modifyfeature.coords[1][subidx][1]"/></v-col>
                      </v-row>
                    </div>
                  </v-tabs-window-item>
                </v-defaults-provider>
              </v-tabs-window>
          </v-card-text>
          <v-card-actions>
            <v-row>
              <v-col cols="3"><v-btn block :text="$t('cancel')" variant="elevated" @click="sub()"/></v-col>
              <v-col cols="3"><v-btn block :text="$t('delete')" color="error" variant="elevated" @click="modFeature('delpop')"/></v-col>
              <v-col><v-btn block :text="$t('save')" variant="elevated" color="primary" @click="modFeature('savepop')"/></v-col>
            </v-row>
          </v-card-actions>
          <v-overlay contained class="align-center justify-center" persistent v-model="meta.featuremodpop">
            <ConfirmCard v-if="meta.modfeaturetype=='delpop'||meta.modfeaturetype=='savepop'" :ttl="$t('aboutpropertyfields')" :cont="meta.modfeaturetype.replace('pop','')" :min-width="300"
             @cancel="modFeature()" @confirm="modFeature(meta.modfeaturetype.replace('pop',''))"/>
          </v-overlay>
        </v-card>
        <v-card v-if="meta.showsub&&meta.showdetail" style="position: absolute;bottom: 4px;right: 5px;z-index: 10;width: calc(100% - 355px);height: 500px;">
          <v-card-title>
            <v-row>
              <v-col>{{ meta.subttl }}</v-col>
              <v-col class="text-right">
                <v-btn variant="text" density="compact" icon="mdi-close" @click="meta.showsub=false"/>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text style="height: 450px;">
            <div v-if="meta.subtype=='selstyle'">
              <v-row>
                <v-col>
                  <v-tabs v-model="meta.selstyletype">
                    <v-tab v-for="type in [meta.selod.layertype.replace('Multi',''),'Manual']" :value="type" @click="searchStyle">
                      {{ $t(type=='Manual'?'sldstylefiles':type) }}
                    </v-tab>
                  </v-tabs>
                </v-col>
                <v-col cols="4" class="text-right">
                  <v-btn :text="$t('managestyles')+' '+$t('shortcuts')" @click="openManStyle"/>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field hide-details variant="outlined" density="compact" :label="$t('stylename')" :placeholder="$t('enteranameforyourstyle')" v-model="meta.searchstylenm" @keyup.enter="searchStyle"/>
                </v-col>
                <v-col cols="1"><v-btn prepend-icon="mdi-magnify" color="secondary" :text="$t('search')" @click="searchStyle"/></v-col>
                <v-col class="text-right">
                  <v-btn class="me-3" :text="$t('refresh')" @click="searchStyle"/>
                  <v-btn color="primary" :text="$t('applying')" @click="saveStyle"/>
                </v-col>
              </v-row>
              <v-table class="editstyletbl" height="320">
                <thead>
                  <tr>
                    <th style="width: 20px;"></th>
                    <th v-for="head in meta.styleheads">{{ $t(head.tk) }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="!meta.styles.rows.length"><td :colspan="meta.styleheads.length+1" class="text-center">{{ $t('noresultsfound') }}</td></tr>
                  <tr v-else v-for="row in meta.styles.rows">
                    <td><v-checkbox hide-details density="compact" :value="row.gsstylenms" v-model="meta.selstyle"/></td>
                    <td v-for="head in meta.styleheads" class="text-center">
                      <img v-if="head.tk=='preview'" style="max-width: 50px;max-height: 50px;" :src="config.backend+'previewstyle/'+row.id"/>
                      <div v-else-if="head.col=='mdt'">{{ ymd(row[head.col]) }}</div>
                      <div v-else-if="head.col=='groupid'">{{ row.groupid?meta.styles.subrows.groups.find(group=>group.id==row.groupid).nm:$t('defaultgroups') }}</div>
                      <div v-else>{{ row[head.col] }}</div>
                    </td>
                  </tr>
                </tbody>
              </v-table>
            </div>
            <div v-if="meta.subtype=='metadata'">
              <v-defaults-provider :defaults="{VTextField:{variant:'outlined',density:'compact',hideDetails:true,placeholder:$t('enteradescriptionupto500characters')}
                ,VTextarea:{variant:'outlined',density:'compact',hideDetails:true,placeholder:$t('enteradescriptionupto500characters')}}">
                <v-table class="editmetatbl">
                  <tbody>
                    <tr>
                      <th>{{ $t('metanm') }}</th>
                      <td colspan="3"><v-text-field v-model="meta.selod.metanm" @keyup="()=>{
                        if(meta.selod.metanm.length>meta.metalim)meta.selod.metanm=meta.selod.metanm.substring(0,meta.metalim)
                      }"/></td>
                    </tr>
                    <tr>
                      <th>{{ $t('metatype') }}</th>
                      <td><v-text-field v-model="meta.selod.metatype" @keyup="()=>{
                        if(meta.selod.metatype.length>meta.metalim)meta.selod.metatype=meta.selod.metatype.substring(0,meta.metalim)
                      }"/></td>
                      <th>{{ $t('metaformat') }}</th>
                      <td><v-text-field v-model="meta.selod.metaformat" @keyup="()=>{
                        if(meta.selod.metaformat.length>meta.metalim)meta.selod.metaformat=meta.selod.metaformat.substring(0,meta.metalim)
                      }"/></td>
                    </tr>
                    <tr>
                      <th>{{ $t('metacrs') }}</th>
                      <td><v-text-field v-model="meta.selod.metacrs" @keyup="()=>{
                        if(meta.selod.metacrs.length>meta.metalim)meta.selod.metacrs=meta.selod.metacrs.substring(0,meta.metalim)
                      }"/></td>
                      <th>{{ $t('metamodinterval') }}</th>
                      <td><v-text-field v-model="meta.selod.metamodinterval" @keyup="()=>{
                        if(meta.selod.metamodinterval.length>meta.metalim)meta.selod.metamodinterval=meta.selod.metamodinterval.substring(0,meta.metalim)
                      }"/></td>
                    </tr>
                    <tr>
                      <th>{{ $t('metaarea') }}</th>
                      <td colspan="3"><v-text-field v-model="meta.selod.metaarea" @keyup="()=>{
                        if(meta.selod.metaarea.length>meta.metalim)meta.selod.metaarea=meta.selod.metaarea.substring(0,meta.metalim)
                      }"/></td>
                    </tr>
                    <tr>
                      <th>{{ $t('metaorg') }}</th>
                      <td colspan="3"><v-text-field v-model="meta.selod.metaorg" @keyup="()=>{
                        if(meta.selod.metaorg.length>meta.metalim)meta.selod.metaorg=meta.selod.metaorg.substring(0,meta.metalim)
                      }"/></td>
                    </tr>
                    <tr>
                      <th>{{ $t('metamethod') }}</th>
                      <td colspan="3"><v-text-field v-model="meta.selod.metamethod" @keyup="()=>{
                        if(meta.selod.metamethod.length>meta.metalim)meta.selod.metamethod=meta.selod.metamethod.substring(0,meta.metalim)
                      }"/></td>
                    </tr>
                    <tr>
                      <th>{{ $t('memo') }}</th>
                      <td colspan="3"><v-textarea class="mt-1 mb-1" rows="3" v-model="meta.selod.metamemo" @keyup="()=>{
                        if(meta.selod.metamemo.length>meta.metalim)meta.selod.metamemo=meta.selod.metamemo.substring(0,meta.metalim)
                      }"/></td>
                    </tr>
                  </tbody>
                </v-table>
              </v-defaults-provider>
            </div>
            <DataDetail v-if="meta.subtype=='datadetail'" :id="meta.selod.id" type="objdetect" tblheight="210"/>
            <Logs v-if="meta.subtype=='log'" :ispop="true" logcate="Objdetect" :targetid="meta.selod.id" :hideclose="true"/>
          </v-card-text>
        </v-card>
      </div>
    </div>
  </MenuLayout>
  <Teleport v-if="meta.subtype=='share'" to="#popbody">
    <MemPicker tkey="sharinglayers" refnm="objdetect" :refid="meta.selod.id" auth="ADMIN,MEMBER" :targettypes="['all','partial']" :targettype="meta.selod.sharetype" @close-pop="sub()" @save-callback="shareSaved"/>
  </Teleport>
  <Teleport v-if="meta.subtype=='save'" to="#popbody">
    <ConfirmCard :ttl="$t('savelayer')" cont="save" @cancel="sub()" @confirm="save"/>
  </Teleport>
</template>
<style>
.editlayer{display: flex;flex-wrap: nowrap;height: 100%;}
.editod_left{width: 350px;}
.editod_left > .v-card{height: calc(100% - 10px);margin: 5px 0 5px 2px;}
.editod_left_tglbtn{cursor: pointer;position: absolute;color:#fff;background-color: #3F51B5;width: 20px;height: 82px;top:0;left: 0;z-index: 9;}
.editlayer .bgselwrap{position: absolute;z-index: 999;top: 6px;left: 28px;width: 322px;}
.editod_right{flex-grow: 1;position: relative;}
.editlayer .splitpanes{height: calc(100vh - 90px);}
.editlayer .splitpanes__pane{background-color: #fff !important;overflow-y: auto;}
.editlayer .splitpanes__splitter {min-height: 12px !important;}
#editmap{position: relative;z-index: 1;}
#editmap .ol-zoom{left: auto;right: 5px;}
#editmap .ol-zoomslider{left: auto;right: 5px;}
.editod_detail{top: 82px;left: 0;z-index: 10;height: calc(100% - 86px);}
.editod_detail p{margin: 10px 0 10px 0;}
.edititemtbl{border: 1px solid #797979;overflow-y: auto;height: 400px;}
.edititemtbl table{border-collapse: collapse;min-width: 100%;}
.edititemtbl th{height: 30px !important;text-align: center !important;background-color: #f2f2f2 !important;border-collapse: collapse;border: 1px solid #e0e0e0;}
.edititemtbl td{white-space: nowrap;text-align: center;border: 1px solid #e0e0e0;padding: 5px;cursor: pointer;}
.edititemtbl tr:has(:checked){background-color: #E8EAF6;}
.editstyletbl,.editmetatbl{border: 1px solid #e0e0e0;margin-top: 10px;}
.editstyletbl th{height: 40px !important;background-color: #eee !important;text-align: center !important; width: 180px;}
.editmetatbl th{width: 130px;background-color: #f2f2f2;}
.vue3-tree-vue span{user-select: none;}
.ol-attribution{display: none;}
.ol-mouse-position{top:auto;bottom: 0;}
.editod_featuredetail{top: 56px;right: 36px;z-index: 10;height: calc(100% - 320px);}
.editod_featuredetail .v-card-text{height: calc(100% - 150px);overflow-y: auto;}
.editod_featuredetail .v-number-input__control button{border-width: 0 !important;}
.editlayer .tree-item-node-parent{width: 100%;}
.editlayertree .tree-item .d-flex > span{width: 150px;}
.v-file-upload-title{font-size: 15px;}
.v-file-upload.v-file-upload--density-compact{padding: 0;}
</style>
